export default __webpack_public_path__ + "static/media/checkbox_white.de22522e.svg";